import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useTheme } from '@emotion/react'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'

import { ErrorContainer, Header, Description } from './StandardError.style'

type ErrorProps = {
  title?: string
  description?: string
  navText?: string
}

const StandardError: React.FC<ErrorProps> = ({ title, description, navText }) => {
  const { t } = useTranslation()
  const { linkColor, linkHoverColor } = useTheme()
  const history = useHistory()

  return (
    <ErrorContainer linkColor={linkColor} hoverColor={linkHoverColor}>
      <Icon icon={faExclamationCircle} size="2x" />
      <Header>{title || t('something_went_wrong')}</Header>
      <Description>{description || t('standard_error_description')}</Description>
      <a
        href="/"
        onClick={(e) => {
          e.preventDefault()
          history.goBack()
        }}
      >
        {navText || t('return_to_previous')}
      </a>
    </ErrorContainer>
  )
}

export default StandardError
